'use strict';

var React = require('react');
var _ = require('lodash');
//components
var RadioInput = require('../Common/RadioInput.jsx');
var OtherFundTypeDetails = require('./OtherFundTypeDetails.jsx');
var DirectDebit = require('./DirectDebit.jsx');
var InternalRollover = require('./InternalRollover.jsx');
//constants
var Constants = require('../../constants/FundingYourProductConstants.js');
var ApplicationConstants = require('../../constants/ApplicationConstants');
var ProductIds = require('../../constants/ApplicationConstants').ProductIds;
//action
var FundingYourProductActions = require('../../actions/FundingYourProductActions.js');
//utils
var Products = require('../../utils/Products.js');
var FundingYourProductHelper = require('../../utils/FundingYourProductHelper.js');


var OtherFundTypes = React.createClass({
    updateStoreModel: function (event) {
        var fieldId = event.target.model;
        var fieldValue = event.target.value;
        if (this.props.inSummary) {
            FundingYourProductActions.updateExistingRollover(fieldId, fieldValue, Constants.RollOverTypes.NON_ROLLOVER, this.props.index);
        } else {
            FundingYourProductActions.updateNewRollover(fieldId, fieldValue, Constants.RollOverTypes.NON_ROLLOVER);
        }
    },

    cancelEditMode: function () {
        if (Products.isInvestment(this.props.product)) {
            this.props.onCancelClick();
        } else {
            FundingYourProductActions.setActiveFundType('');
            FundingYourProductActions.toggleFundingTypeVisibility();
        }
    },

    finishEditMode: function () {
        if (Products.isInvestment(this.props.product)) {
            this.props.onDoneClick();
        } else {
            FundingYourProductActions.submitOtherFundType(this.props.activeFundType);
            if (FundingYourProductHelper.isDirectDebit(this.props.data) && this.props.data.errorList.length === 0 && this.props.data.hideBankAccountListValid) {
                FundingYourProductActions.setActiveFundType('');
            }
            else if (!FundingYourProductHelper.isDirectDebit(this.props.data) && this.props.data.errorList.length === 0) {
                FundingYourProductActions.setActiveFundType('');
            }
        }     
    },   
    disableDirectDebitButton: function (data) {
        _.forEach(data, function (o) {
            if (o.id === 'DD') {
                o.isDisabled = true;
            }
        });
    },
    render: function () {
        //local variables
        var contributions = null;
        var cancelEditMode = this.props.inSummary ? this.props.onCancelClick : this.cancelEditMode;
        var finishEditMode = this.props.inSummary ? this.props.onDoneClick : this.finishEditMode;
        var fundTypeLabel = Products.isInvestment(this.props.product) ? 'How will this investment be made?' : 'How would you be transferring the funds?';
        //Other fund types options
        if (this.props.product === ProductIds.SUPER && this.props.activeFundType === Constants.FundingTypes.Personal_contribution ||
            this.props.product === ProductIds.SUPER && this.props.activeFundType === Constants.FundingTypes.Spouse_contribution) {

            contributions = Constants.OtherContribution.SUPER;

        } else if (Products.isInvestment(this.props.product)) {
            if (this.props.inSummary) {
                contributions = Constants.OtherContribution.SUPER;
            } else {
                if (this.props.hasDirectDebit) {
                    var list = _.cloneDeep(this.props.paymentMethodsInvestment);
                    this.disableDirectDebitButton(list);
                    contributions = list;
                } else {
                    contributions = this.props.paymentMethodsInvestment;
                }
                
            }
        } else {
            contributions = Constants.OtherContribution.OTHERS;
        }
        var showPaymentMethods = true;
        if (Products.isInvestment(this.props.product) && this.props.inSummary) {
            showPaymentMethods = false;
        }
        var showNoticeOfIntent = Products.isPension(this.props.product) && this.props.activeFundType === Constants.FundingTypes.Personal_contribution && this.props.data.paymentMethod !== '';
        
        return (
            <div id="fypOtherFundTypes">
                {showPaymentMethods ? 
                <RadioInput id="fypOtherFundTypesPaymentMethod"
                            model="paymentMethod"
                            label={fundTypeLabel}
                            data={contributions}
                            value={this.props.data.paymentMethod}
                            onChange={this.updateStoreModel}
                            errorList={this.props.data.errorList} /> : null}
                 <RadioInput id="fypClaimTaxDeduction"
                             model="claimTaxDeduction"
                             label="Will you be claiming a tax deduction?"
                             data={ApplicationConstants.YesNoRadioData}
                             value={this.props.data.claimTaxDeduction}
                             onChange={this.updateStoreModel}
                             errorList={this.props.data.errorList}
                             isHidden={!showNoticeOfIntent} /> 
                 <DirectDebit bankAccountList={this.props.bankAccountList}
                              data={this.props.data}
                              product={this.props.product}
                              content={this.props.content}
                              index={this.props.index}
                              inSummary={this.props.inSummary}
                              activeFundType={this.props.activeFundType}
                              futureRequestText={this.props.futureRequestText}
                              directDebitAlreadyAddedText={this.props.directDebitAlreadyAddedText}
                              onCancelClick={cancelEditMode}
                              onDoneClick={finishEditMode} />
                {Products.isInvestment(this.props.product) ? <InternalRollover content={this.props.content}
                                  data={this.props.data}
                                  inSummary={this.props.inSummary}
                                  internalAccounts={this.props.internalAccounts}
                                  product={this.props.product}
                                  activeFundType={this.props.activeFundType}
                                  internalRolloverInfo={this.props.internalRolloverInfo}
                                  onCancelClick={cancelEditMode}
                                  onDoneClick={finishEditMode} />: null}
                {this.props.data.paymentMethod ?<OtherFundTypeDetails data={this.props.data}
                                                                      product={this.props.product}
                                                                      content={this.props.content}
                                                                      index={this.props.index}
                                                                      activeFundType={this.props.activeFundType}
                                                                      onCancelClick={cancelEditMode}
                                                                      onDoneClick={finishEditMode}
                                                                      inSummary={this.props.inSummary} /> : null}

            </div>
		);
    }
});

module.exports = OtherFundTypes;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/FundingYourProduct/OtherFundTypes.jsx